import * as React from 'react';

import { SidebarNavItem } from '../types';
import { useSidebar } from '../context';

import { cn } from '@/lib/utils';

export interface SectionNavProps {
  className?: string;
  items: SidebarNavItem[];
  activeId?: string;
}

export function SectionNav({ className, items, activeId }: SectionNavProps) {
  const { ItemLinkComponent } = useSidebar();

  return (
    <nav className={cn('flex flex-col', className)} aria-label="App section navigation">
      {items.map((item) => (
        <ItemLinkComponent
          key={item.id}
          href={item.href}
          data-sidebar-item-id={item.id}
          data-sidebar-item-type="section"
          data-sidebar-section-nav-item-selected={item.id === activeId}
          className={cn(
            'flex p-2 mx-4 text-base text-default relative rounded-lg',
            'after:transition-opacity after:absolute after:top-0 after:bottom-0 after:-right-4 after:w-2 after:bg-primary after:rounded-l-md after:opacity-0',
            'hover:bg-lime-100 focus:bg-lime-100 hover:text-primary-foreground focus:text-primary-foreground',
            item.id === activeId && 'font-bold after:opacity-100',
          )}
        >
          {item.label}
        </ItemLinkComponent>
      ))}
    </nav>
  );
}
